import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { Prefecture } from './prefecture.model';
import { prefectures } from './prefectures.mock';

@Injectable({
  providedIn: 'root',
})
export class EoPrefectureDropdownService {
  data$ = new BehaviorSubject<Prefecture[] | null>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  init() {
    this.data$.next(null);
  }

  getPrefectures(url: string): Observable<Prefecture[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.data$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<Prefecture[]>(param);
  }

  getPrefecturesMock(): Observable<Prefecture[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<Prefecture[]>((sub) => {
      setTimeout(() => {
        sub.next(prefectures);
        this.data$.next(prefectures);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }
}
